import React from 'react';

// eslint-disable-next-line react/prop-types
const UserMissing: React.FC<React.SVGProps<SVGSVGElement>> = ( { fill, ...props } ) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="-2 -2 28 28"
      strokeWidth="1.5"
      stroke="currentColor"
      {...props}
    >
      <rect width="24" height="24" x="0" y="0" rx="2" fill={fill} stroke="#404040" />
      <path d="M15 16L20 21M20 16L15 21M4 21C4 17.134 7.13401 14 11 14M15 7C15 9.20914 13.2091 11 11 11C8.79086 11 7 9.20914 7 7C7 4.79086 8.79086 3 11 3C13.2091 3 15 4.79086 15 7Z"
        strokeWidth="2" fill="none" stroke="#404040" strokeLinecap="round" strokeLinejoin="round"></path>
    </svg>
  );
};

export { UserMissing };
